export const getTypeSummaryHours = (row, timeTypeId) => {
  const match = (row.typeSummaries || []).find(typeSummary => typeSummary.timeTypeId === timeTypeId)
  return match ? match.hours : 0
}

export default getTypeSummaryHours
